import { useState } from "react";

import {
    nameValidator,
    englishNameValidator,
    addressValidator,
    locationValidator
} from "./validators.js";

const touchErrors = errors => {
    return Object.entries(errors).reduce((acc, [field, fieldError]) => {
        acc[field] = {
            ...fieldError,
            dirty: true,
        };
        return acc;
    }, {});
};

export const useDataFormValidator = baseInformation => {
    const [errors, setErrors] = useState({

        name: {
            dirty: false,
            error: false,
            message: "",
        },
        englishName: {
            dirty: false,
            error: false,
            message: "",
        },
        address: {
            dirty: false,
            error: false,
            message: "",
        },
        location: {
            dirty: false,
            error: false,
            message: "",
        },
    });

    const validateForm = ({ baseInformation, field, errors, forceTouchErrors = false }) => {
        let isValid = true;

        // Create a deep copy of the errors
        let nextErrors = JSON.parse(JSON.stringify(errors));

        // Force validate all the fields
        if (forceTouchErrors) {
            nextErrors = touchErrors(errors);
        }

        const { name, english_name, address, location } = baseInformation;

        if (nextErrors.name.dirty && (field ? field === "name" : true)) {
            const nameMessage = nameValidator(name, baseInformation);
            nextErrors.name.error = !!nameMessage;
            nextErrors.name.message = nameMessage;
            if (!!nameMessage) isValid = false;
        }

        if (nextErrors.english_name?.dirty && (field ? field === "english_name" : true)) {
            const englishNameMessage = englishNameValidator(english_name, baseInformation);
            nextErrors.english_name.error = !!englishNameMessage;
            nextErrors.english_name.message = englishNameMessage;
            if (!!englishNameMessage) isValid = false;
        }

        if (nextErrors.address.dirty && (field ? field === "address" : true)) {
            const addressMessage = addressValidator(address, baseInformation);
            nextErrors.address.error = !!addressMessage;
            nextErrors.address.message = addressMessage;
            if (!!addressMessage) isValid = false;
        }
        if (nextErrors.location.dirty && (field ? field === "location" : true)) {
            const locationMessage = locationValidator(location, baseInformation);
            nextErrors.location.error = !!locationMessage;
            nextErrors.location.message = locationMessage;
            if (!!locationMessage) isValid = false;
        }

        setErrors(nextErrors);

        return {
            isValid,
            errors: nextErrors,
        };
    };

    const onBlurField = e => {
        const field = e.target.name;
        const fieldError = errors[field];
        if (fieldError?.dirty) return;

        const updatedErrors = {
            ...errors,
            [field]: {
                ...errors[field],
                dirty: true,
            },
        };

        validateForm({ baseInformation, field, errors: updatedErrors });
    };

    return {
        validateForm,
        onBlurField,
        errors,
    };
};